// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".env-banner{background-color:var(--v-primary-base);color:#fff;display:grid;left:0;padding:.5rem 4.6875rem .5rem .8125rem;pointer-events:none;position:absolute;text-align:center;top:3.375rem;transform:rotate(-22.5deg);transform-origin:bottom left;width:15.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
